import {NotificationMessage} from './NotificationMessage';
import {ApiResult} from "../ApiResult";

export class NotificationMessageResult extends ApiResult {
  item!: NotificationMessage;
  constructor(data: any) {
    super(data);
    console.log(data);
    if (data !== null && data.item !== null) {
      console.log(data.item);
      this.item = new NotificationMessage(data.item);
    }
  }
}
